/**
 * BillingSuccess — route /billing/success
 *
 * Stripe redirects here after a successful checkout.
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logoUrl from '../../assets/images/cleveroo-logo.png';
import { trackPaidConversion } from '../../api/analytics';
import '../../components/AccountPages.css';

const BillingSuccess: React.FC = () => {
  const navigate = useNavigate();

  // Fire the paid-conversion funnel event once per checkout return so
  // channel → quiz-start → paid is actually measurable (ROO-81). Guarded by the
  // Stripe session_id so a refresh of this page doesn't double-count. UTM is
  // auto-merged by track(), preserving the original acquisition channel.
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const sessionId = params.get('session_id') || 'unknown';
      const plan = params.get('plan') || undefined;
      const key = `cvr_paidconv_${sessionId}`;
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, '1');
        void trackPaidConversion(plan);
      }
    } catch {
      void trackPaidConversion();
    }
  }, []);

  return (
    <div className="cvr-account">
      <div className="cvr-account__bar">
        <span className="cvr-account__brand">
          <img src={logoUrl} alt="" />
          Cleveroo
        </span>
      </div>

      <div
        className="cvr-account__wrap"
        style={{ maxWidth: 520, textAlign: 'center' }}
      >
        {/* Success icon */}
        <div
          style={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #5DAA3A, #14593C)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '32px auto 0',
          }}
        >
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        <h1
          className="cvr-account__title"
          style={{ fontSize: 28, marginTop: 24, textAlign: 'center' }}
        >
          You're all set!
        </h1>
        <p
          style={{
            color: '#6B7A6F',
            fontSize: 16,
            marginTop: 12,
            lineHeight: 1.65,
          }}
        >
          Your free trial has started. Explore everything Cleveroo has to offer
          — we'll remind you a few days before your trial ends.
        </p>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            marginTop: 32,
            alignItems: 'center',
          }}
        >
          <button
            className="cvr-btn"
            onClick={() => navigate('/')}
            style={{ padding: '13px 32px', fontSize: 15 }}
          >
            Go to dashboard
          </button>
          <button
            className="cvr-btn cvr-btn--ghost"
            onClick={() => navigate('/billing')}
            style={{ fontSize: 14 }}
          >
            View subscription
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillingSuccess;
